import React, { Component } from "react";
import T from "../t/T";
import "./Label.scss";

export default class Label extends Component {

  onClickHandler = () => {
    this.props?.onClick && this.props?.onClick()
  }

  render() {
    const { className = "", inputLabel = true, removeColon = false, icon, iconColor, labelText = "", labelTextColor, labelRawText = "", rawTextColor, color } = this.props;

    return <label className={`${className} ${inputLabel ? "input__label" : "simple__label"} label-${color} ${this.props?.onClick ? "clickable" : ""}`}
                  onClick={this.onClickHandler}
                  style={{'--def-color': color}}
    >
      { icon &&
        <span className={`icon_before_colon`} style={{'--color0': (iconColor ?? labelTextColor) ?? color}}> <i className={`${icon}`}/> </span>}
      <span className={`label_before_colon`} style={{ '--color1': labelTextColor ?? color }}> <T token={labelText} /> </span>
      { !removeColon &&
          <span className={`colon`} > {": "} </span> }

      <div className={`label_after_colon`} style={{ '--color2': rawTextColor ?? color }}> {labelRawText} </div>
    </label>;
  }
}
